import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const ToastrCheck = (props: IIconProps) => (
  <BaseIcon width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(.922 .98)" fill="none" fillRule="evenodd">
      <circle fill={EColors.WHITE} cx="16.396" cy="16.396" r="16.396" />
      <path stroke={EColors.LIGHT_BLUE} strokeWidth="2.43" d="m9.32 17.644 3.89 3.888L23.471 11.27" />
    </g>
  </BaseIcon>
)

export default ToastrCheck
